/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Field/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Field({
  children,
  viewPath = "/DesignSystem/AppointmentActions/Unseat/Content/MissingRequiredTreatmentFieldsDialog/Content/TreatmentFields/Content/Field"
  
}) {
let constantData = '-'
let txCardFieldNameValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field',
path: 'name',
})
let aggregateData = fromAggregate.join(constantData, txCardFieldNameValueData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 data="'-'"
 data="tx_card_field.name"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}